import JsonLd from '@/components/JsonLd'
import { serviceSchema, breadcrumbSchema } from '@/lib/jsonLdSchemas'
import Navbar from '@/components/layout/Navbar'
import Footer from '@/components/layout/Footer'
import AuthorityHero from '@/components/sections/authority/AuthorityHero'
import AuthorityServices from '@/components/sections/authority/AuthorityServices'
import AuthorityPricing from '@/components/sections/authority/AuthorityPricing'
import AuthorityContact from '@/components/sections/authority/AuthorityContact'
import ServiceNav from '@/components/sections/ServiceNav'

export default function Authority() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground selection:bg-accent selection:text-white">
      <JsonLd data={serviceSchema({ name: 'SEO & Content', description: 'Technical foundations and content strategies that build long-term dominance. Own the keywords that drive revenue.', path: '/authority' })} />
      <JsonLd data={breadcrumbSchema([{ name: 'Services', path: '/#services' }, { name: 'Authority', path: '/authority' }])} />
      <Navbar />
      <main>
        <AuthorityHero />
        <AuthorityServices />
        <AuthorityPricing />
        <AuthorityContact />
        <ServiceNav />
      </main>
      <Footer />
    </div>
  )
}
